import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import messages from '../../CompaniesView.intl';

//import style
import styles from './InfoBox.module.scss';

@injectIntl
export default class InfoBoxComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    company: PropTypes.object,
    isLeftFloat: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    company: {},
    isLeftFloat: true
  };

  render() {
    const { className, company, isLeftFloat } = this.props;
    return (
      <div
        className={`${styles.InfoBox}  ${
          isLeftFloat ? styles.InfoBoxFloatLeft : ''
        } ${className}`}
      >
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.legalForm)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>{company.legalForm}</div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.address)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>{company.address}</div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.country)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            {company.registrationCountry}
          </div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.nip)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>{company.taxIdNumber}</div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.regon)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            {company.statisticalNumber}
          </div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.krs)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            {company.courtRegistrationNumber}
          </div>
        </div>
        {company.dunsNumber && (
          <div className={styles.InfoBoxRow}>
            <div className={styles.InfoBoxLeftColumn}>
              {this.props.intl.formatMessage(messages.duns)}:
            </div>
            <div className={styles.InfoBoxRightColumn}>
              {company.dunsNumber}
            </div>
          </div>
        )}
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.amountOfCapital)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            {company.shareCapital}
          </div>
        </div>
        {company.shares && (
          <div className={styles.InfoBoxRow}>
            <div className={styles.InfoBoxLeftColumn}>
              {this.props.intl.formatMessage(messages.shares)}:
            </div>
            <div className={styles.InfoBoxRightColumn}>{company.shares}</div>
          </div>
        )}
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.website)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            <a
              href={company.website.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.InfoBoxLink}
            >
              {company.website.hostname}
            </a>
          </div>
        </div>
        <div className={styles.InfoBoxRow}>
          <div className={styles.InfoBoxLeftColumn}>
            {this.props.intl.formatMessage(messages.contact)}:
          </div>
          <div className={styles.InfoBoxRightColumn}>
            <a
              href={`mailto:${company.contact}`}
              className={styles.InfoBoxLink}
            >
              {company.contact}
            </a>
          </div>
        </div>
        {company.subsidiaries && (
          <div className={styles.InfoBoxRow}>
            <div className={styles.InfoBoxLeftColumn}>
              {this.props.intl.formatMessage(messages.subsidiaries)}:
            </div>
            <div className={styles.InfoBoxRightColumn}>
              {company.subsidiaries}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Companies/components/InfoBox/InfoBox.js